export default __webpack_public_path__ + "static/media/zamenhof.f3a679b3.png";